export const DriverCompensationReasons = Object.freeze(
  [
    {
      id: 'RIDE_ISSUE',
      Description: 'Issue during a drive',
    },
    {
      id: 'CANCELLATION_MAKEUP',
      Description: 'Cancellation make-up',
    },
    {
      id: 'MISSED_EARNINGS',
      Description: 'Missed earnings correction',
    },
    {
      id: 'TOLL_OR_EXPENSE',
      Description: 'Toll or expense reimbursement',
    },
    {
      id: 'DRIVER_INCENTIVE',
      Description: 'Driver incentive',
    },
    {
      id: 'GOODWILL',
      Description: 'Goodwill / retention',
    },
    {
      id: 'FLEET_HOURLY',
      Description: 'Fleet hourly pay',
    },
  ].sort((a, b) => a.Description.localeCompare(b.Description)),
);
